import { createAsyncThunk } from "@reduxjs/toolkit"

import apiClient from "src/apiClient"
import userReducers from "../reducers"

/* A guest presses Google. The authenticated link endpoint answers a guest with a token pair: the
   guest's own (now saved) when that Google account was nobody's here, or the session of the account
   it already opens (`switched`). The caller reloads the bootstrap either way.

   An account that is no longer a guest — saved by email in another tab while this one still reads
   `isGuest` — gets the ordinary link answer, which carries no tokens; writing `undefined` ones
   logged the player out of the account they had just saved. */
export const thunk = createAsyncThunk("user/claimGuestWithGoogle", async (credential, { rejectWithValue }) => {
  try {
    const response = await apiClient.post("/auth/google/link/", { credential }, { handlesOwnErrors: true })
    const tokens = response.data.access && response.data.refresh
    return {
      refreshToken: tokens ? response.data.refresh : null,
      accessToken: tokens ? response.data.access : null,
      switched: Boolean(response.data.switched),
      linked: !tokens,
    }
  } catch (error) {
    return rejectWithValue(error.response?.data || { detail: "Could not reach the server." })
  }
})

// Only the tokens, and only when the answer carried a pair: who the account is now comes from the
// `/users/me/` that follows.
export const onSucceed = (state, action) => {
  if (action.payload.accessToken) userReducers.setTokens(state, action)
}

const thunkObject = { thunk, onSucceed }
export default thunkObject
